/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Guard_LeadInputs */

const en_mk_sec_pg_guard_lead = /** @type {(inputs: Mk_Sec_Pg_Guard_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every one of these is enforced server-side. An agent cannot talk itself past them, and an instruction telling it to break one will not work.`)
};

const id_mk_sec_pg_guard_lead = /** @type {(inputs: Mk_Sec_Pg_Guard_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua batas ini ditegakkan di sisi server. Agen tidak bisa membujuk dirinya sendiri untuk melewatinya, dan instruksi yang menyuruhnya melanggar tidak akan berhasil.`)
};

/**
* | output |
* | --- |
* | "Every one of these is enforced server-side. An agent cannot talk itself past them, and an instruction telling it to break one will not work." |
*
* @param {Mk_Sec_Pg_Guard_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_guard_lead = /** @type {((inputs?: Mk_Sec_Pg_Guard_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Guard_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_guard_lead(inputs)
	return en_mk_sec_pg_guard_lead(inputs)
});